import { HpLoadingWidgetProps } from './widgetTypes';

export type HpLoadingWidgetFunction = (props: HpLoadingWidgetProps) => JSX.Element;

export function LoadingWidgetOverlay({ viewport }: HpLoadingWidgetProps): JSX.Element {
  const { height } = viewport;
  return (
    <div className="hp-overlay-box-translucent">
      <div className="hp-loading-overlay">
        <div className="logo-loading" style={{ marginTop: `${Math.floor(height * 0.35)}px` }}></div>
      </div>
    </div>
  );
}
